import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mic2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import VoicePicker from "@/components/voicesongs/VoicePicker";
import { singSong } from "@/lib/voiceSongsApi";
import { safeApiError } from "@/lib/safeErrorText";

/** Sing a library song in your trained voice — every vocal, backing singers too. */
export default function SingInMyVoiceDialog({ open, onClose, song, onStarted }) {
  const [pick, setPick] = useState({ voice_id: null, pitch: 0 });
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await singSong({ song_id: song.id, ...pick }); toast.success("Singing it in your voice…", { description: "Usually 3–8 minutes. You can leave this page." }); onStarted(); onClose(); }
    catch (e) { toast.error("Couldn't start", { description: safeApiError(e) }); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="sing-my-voice-dialog" className="max-w-md border-white/10 bg-[#0b0e1c] text-white">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display"><Mic2 className="h-4 w-4 text-cyan-300" /> Sing “{song.title}” in my voice</DialogTitle>
          <DialogDescription className="text-white/60">Every vocal — lead and backing singers — is re-sung in your trained voice, then put back with the music. The original song stays as it is.</DialogDescription>
        </DialogHeader>
        {open ? <VoicePicker value={pick} onChange={setPick} onReady={setReady} /> : null}
        <p className="mt-4 text-[11px] leading-relaxed text-white/40">Splitting the vocals uses a little AI credit; the singing runs on your Replicate account (a few cents per song).</p>
        <button type="button" data-testid="sing-my-voice-start" onClick={go} disabled={busy || !ready || !pick.voice_id}
          className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-cyan-300 py-2.5 text-[13px] font-semibold text-black disabled:opacity-40">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mic2 className="h-4 w-4" />} Sing it in my voice
        </button>
      </DialogContent>
    </Dialog>
  );
}
